<template>
  <flow-part :id="$options.name" class="form-part">
    <template #heading>
      <h2>Maandelijkse betaling</h2>
    </template>
    <template #content>
      <div class="payment">
        <div class="notice">Bij {{ orderStore.product.provider_name }} betaal je met automatische incasso.</div>
        <div class="text-group">

          <text-input id="iban" v-model.capitalize="orderStore.iban" v-model:error="orderStore.errors.iban"
            label="IBAN rekeningnummer" autocomplete="iban" show-valid placeholder=" " />

            <div class="different_holder_name">
          <checkbox-input id="different_holder_name" v-model="orderStore.different_holder_name"
            v-model:error="orderStore.errors.different_holder_name">
            Rekening staat op andere naam
          </checkbox-input>
        </div>

          <text-input v-if="orderStore.different_holder_name" id="iban_holder_name" v-model="orderStore.iban_holder_name"
            v-model:error="orderStore.errors.iban_holder_name" label="Naam rekeninghouder" show-valid />
        </div>
      </div>
    </template>
  </flow-part>
</template>

<script>
import TextInput from 'vue-elements/input/TextInput.vue';
import CheckboxInput from 'vue-elements/input/CheckboxInput.vue';
import FormPartMixin from '../../lib/FormPartMixin';
import FlowPart from '../FlowPart.vue';
import { useOrderStore } from '../../stores/orderStore';

export default {
  name: 'ConfirmPart',
  mixins: [FormPartMixin()],
  components: {
    CheckboxInput,
    TextInput,
    FlowPart,
  },
  setup() {
    const orderStore = useOrderStore();

    return {
      orderStore,
    };
  },
};
</script>

<style lang="scss" scoped>
@use '../../style/helpers';
@use 'assets/scss/_helpers/breakpoint';

.payment {
  margin-left: -4px;
}

.different_holder_name {
  margin-bottom: 12px;
  margin-top: -12px;
}

.notice {
  font-size: 16px;
  margin-left: 4px;
  margin-top: 0px;
  margin-bottom: 18px;

  @include breakpoint.up(lg) {
    margin-top: -12px;
  }
}

.checkbox-input-field {
  margin-left: 4px;
}

.text-input,
.checkbox-input-field {
  @include helpers.field-group-spacing-bottom();

}
</style>
